module.exports = __webpack_public_path__ + "static/img/3_2_1_1.55587d90.jpg";